import React, { Component } from 'react';


class Step12 extends Component {

    render() {
        return (
            <div className="card card-body">

                {/* Device 9 */}
                <div className="form-group">
                    <div className="row">
                        <div className="col-sm-12">Device 9</div>
                        <div className="col-sm-12 col-md-6">
                            <div className="form-group">
                                <input id="c4loc9" name="c4loc9" type="text" placeholder='Location' className="form-control here" />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-6 col-md-6">
                            <div className="form-group">
                                <input id="c4dev9" name="c4dev9" type="text" placeholder='Device' className="form-control here" />
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-6">
                            <div className="form-group">
                                <label htmlFor="c4correct9">Correctly Installed</label>
                                <select id="c4correct9" name="c4correct9" className="custom-select" >
                                    <option selected value='NOT APPLICABLE'>NOT APPLICABLE</option>
                                    <option value="YES">YES</option>
                                    <option value="NO">NO</option>
                                </select>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-6">
                            <div className="form-group">
                                <label htmlFor="c4serv9">Requires Service</label>
                                <select id="c4serv9" name="c4serv9" className="custom-select" >
                                    <option selected value='NOT APPLICABLE'>NOT APPLICABLE</option>
                                    <option value="YES">YES</option>
                                    <option value="NO">NO</option>
                                </select>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-6">
                            <div className="form-group">
                                <label htmlFor="c4conf9">Alarm Operation Confirmed</label>
                                <select id="c4conf9" name="c4conf9" className="custom-select" >
                                    <option selected value='NOT APPLICABLE'>NOT APPLICABLE</option>
                                    <option value="YES">YES</option>
                                    <option value="NO">NO</option>
                                </select>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-6">
                            <div className="form-group">
                                <label htmlFor="cann9">Annunciation Confirmed</label>
                                <select id="c4ann9" name="c4ann9" className="custom-select" >
                                    <option selected value='NOT APPLICABLE'>NOT APPLICABLE</option>
                                    <option value="YES">YES</option>
                                    <option value="NO">NO</option>
                                </select>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-6">
                            <div className="form-group">
                                <label htmlFor="c4conf9">CIRCUIT/ZONE/POINT/ADDRESS</label>
                                <input id="c4circzone9" name="c4circzone9" type="text" placeholder='CIRCUIT/ZONE/POINT/ADDRESS' className="form-control here" />
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-6">
                            <div className="form-group">
                                <label htmlFor="c4supfault9">Supervision/Ground Fault</label>
                                <select id="c4supfault9" name="c4supfault9" className="custom-select" >
                                    <option selected value='NOT APPLICABLE'>NOT APPLICABLE</option>
                                    <option value="YES">YES</option>
                                    <option value="NO">NO</option>
                                </select>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-6">
                            <div className="form-group">
                                <label htmlFor="c4conf9">Remarks</label>
                                <textarea id="c4remarks9" name="c4remarks9" type="text" className="form-control here"></textarea>
                            </div>
                        </div>
                    </div>
                    <hr />
                </div>


                {/* Device 10 */}
                <div className="form-group">
                    <div className="row">
                        <div className="col-sm-12">Device 10</div>
                        <div className="col-sm-12 col-md-6">
                            <div className="form-group">
                                <input id="c4loc10" name="c4loc10" type="text" placeholder='Location' className="form-control here" />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-6 col-md-6">
                            <div className="form-group">
                                <input id="c4dev10" name="c4dev10" type="text" placeholder='Device' className="form-control here" />
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-6">
                            <div className="form-group">
                                <label htmlFor="c4correct10">Correctly Installed</label>
                                <select id="c4correct10" name="c4correct10" className="custom-select" >
                                    <option selected value='NOT APPLICABLE'>NOT APPLICABLE</option>
                                    <option value="YES">YES</option>
                                    <option value="NO">NO</option>
                                </select>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-6">
                            <div className="form-group">
                                <label htmlFor="c4serv10">Requires Service</label>
                                <select id="c4serv10" name="c4serv10" className="custom-select" >
                                    <option selected value='NOT APPLICABLE'>NOT APPLICABLE</option>
                                    <option value="YES">YES</option>
                                    <option value="NO">NO</option>
                                </select>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-6">
                            <div className="form-group">
                                <label htmlFor="c4conf10">Alarm Operation Confirmed</label>
                                <select id="c4conf10" name="c4conf10" className="custom-select" >
                                    <option selected value='NOT APPLICABLE'>NOT APPLICABLE</option>
                                    <option value="YES">YES</option>
                                    <option value="NO">NO</option>
                                </select>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-6">
                            <div className="form-group">
                                <label htmlFor="cann10">Annunciation Confirmed</label>
                                <select id="c4ann10" name="c4ann10" className="custom-select" >
                                    <option selected value='NOT APPLICABLE'>NOT APPLICABLE</option>
                                    <option value="YES">YES</option>
                                    <option value="NO">NO</option>
                                </select>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-6">
                            <div className="form-group">
                                <label htmlFor="c4conf10">CIRCUIT/ZONE/POINT/ADDRESS</label>
                                <input id="c4circzone10" name="c4circzone10" type="text" placeholder='CIRCUIT/ZONE/POINT/ADDRESS' className="form-control here" />
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-6">
                            <div className="form-group">
                                <label htmlFor="c4supfault10">Supervision/Ground Fault</label>
                                <select id="c4supfault10" name="c4supfault10" className="custom-select" >
                                    <option selected value='NOT APPLICABLE'>NOT APPLICABLE</option>
                                    <option value="YES">YES</option>
                                    <option value="NO">NO</option>
                                </select>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-6">
                            <div className="form-group">
                                <label htmlFor="c4conf10">Remarks</label>
                                <textarea id="c4remarks10" name="c4remarks10" type="text" className="form-control here"></textarea>
                            </div>
                        </div>
                    </div>
                    <hr />
                </div>

                {/* Device 11 */}
                <div className="form-group">
                    <div className="row">
                        <div className="col-sm-12">Device 11</div>
                        <div className="col-sm-12 col-md-6">
                            <div className="form-group">
                                <input id="c4loc11" name="c4loc11" type="text" placeholder='Location' className="form-control here" />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-6 col-md-6">
                            <div className="form-group">
                                <input id="c4dev11" name="c4dev11" type="text" placeholder='Device' className="form-control here" />
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-6">
                            <div className="form-group">
                                <label htmlFor="c4correct11">Correctly Installed</label>
                                <select id="c4correct11" name="c4correct11" className="custom-select" >
                                    <option selected value='NOT APPLICABLE'>NOT APPLICABLE</option>
                                    <option value="YES">YES</option>
                                    <option value="NO">NO</option>
                                </select>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-6">
                            <div className="form-group">
                                <label htmlFor="c4serv11">Requires Service</label>
                                <select id="c4serv11" name="c4serv11" className="custom-select" >
                                    <option selected value='NOT APPLICABLE'>NOT APPLICABLE</option>
                                    <option value="YES">YES</option>
                                    <option value="NO">NO</option>
                                </select>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-6">
                            <div className="form-group">
                                <label htmlFor="c4conf11">Alarm Operation Confirmed</label>
                                <select id="c4conf11" name="c4conf11" className="custom-select" >
                                    <option selected value='NOT APPLICABLE'>NOT APPLICABLE</option>
                                    <option value="YES">YES</option>
                                    <option value="NO">NO</option>
                                </select>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-6">
                            <div className="form-group">
                                <label htmlFor="cann11">Annunciation Confirmed</label>
                                <select id="c4ann11" name="c4ann11" className="custom-select" >
                                    <option selected value='NOT APPLICABLE'>NOT APPLICABLE</option>
                                    <option value="YES">YES</option>
                                    <option value="NO">NO</option>
                                </select>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-6">
                            <div className="form-group">
                                <label htmlFor="c4conf11">CIRCUIT/ZONE/POINT/ADDRESS</label>
                                <input id="c4circzone11" name="c4circzone11" type="text" placeholder='CIRCUIT/ZONE/POINT/ADDRESS' className="form-control here" />
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-6">
                            <div className="form-group">
                                <label htmlFor="c4supfault11">Supervision/Ground Fault</label>
                                <select id="c4supfault11" name="c4supfault11" className="custom-select" >
                                    <option selected value='NOT APPLICABLE'>NOT APPLICABLE</option>
                                    <option value="YES">YES</option>
                                    <option value="NO">NO</option>
                                </select>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-6">
                            <div className="form-group">
                                <label htmlFor="c4conf11">Remarks</label>
                                <textarea id="c4remarks11" name="c4remarks11" type="text" className="form-control here"></textarea>
                            </div>
                        </div>
                    </div>
                    <hr />

                </div>



            </div>
        );
    }
};

export default Step12;



// WEBPACK FOOTER //
// ./src/components/Step13.js